import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import {
  emptyNodeDataObject,
  updateActiveInitialStructureNode,
  updateActiveMachineStructureNode,
} from "@src/reducers/your-reducer";
import { ChildType } from "@common/types/tree-types";

import cn from "classnames";
import {
  writeEmptyNodeDetails,
  writeNodeDetailsOurNode,
} from "./use-cases/write-node-details-our-node";

import styles from "../TreeComponents.module.scss";
import { returnIconForChild } from "../../use-cases/return-icon-for-child";
interface NameWrapperOurNodePropTypes {
  child: ChildType;
  type: "initial" | "machine";
  list: ChildType[];
  transferred: boolean;
}

export const NameWrapperOurNode = ({
  child,
  type,
  list,
  transferred,
}: NameWrapperOurNodePropTypes) => {
  const dispatch = useDispatch();

  const handleWriteNodeDetails = useCallback(
    (child) => {
      writeNodeDetailsOurNode(dispatch, child, list, type);
    },
    [dispatch, list, type],
  );

  const handleWriteEmptyNodeDetails = useCallback(
    (child) => {
      writeEmptyNodeDetails(dispatch, child);
    },
    [dispatch],
  );

  const handleClickOnNode = useCallback(
    (type) => {
      if (child.name !== "Root" && type === "machine" && !child.unassigned) {
        handleWriteNodeDetails(child);
        dispatch(updateActiveMachineStructureNode(child.key));
        dispatch(updateActiveInitialStructureNode(""));
      } else if (child.name !== "Root" && type === "initial") {
        handleWriteNodeDetails(child);
        dispatch(updateActiveInitialStructureNode(child.key));
        dispatch(updateActiveMachineStructureNode(""));
      } else {
        handleWriteEmptyNodeDetails(emptyNodeDataObject);
        dispatch(updateActiveMachineStructureNode(""));
        dispatch(updateActiveInitialStructureNode(""));
      }
    },
    [child, handleWriteNodeDetails, dispatch, handleWriteEmptyNodeDetails],
  );

  return (
    <span
      onClick={() => handleClickOnNode(type)}
      onKeyDown={() => handleClickOnNode(type)}
      role="button"
      className={cn(
        styles["tree-node__name-wrapper"],
        styles[`tree-node__name-wrapper--${returnIconForChild(child)}`],
        {
          [styles["tree-node__name-wrapper--transferred"]]: transferred,
          [styles["tree-node__name-wrapper--unassigned"]]: child.unassigned,
        },
      )}
      tabIndex={0}
    >
      {child.name}
    </span>
  );
};
